import React from "react";
import {Link} from "react-router-dom";

const NavigationSidebar = (
    {
       active = 'home'
    }) => {
  const isActive = (active, path) => `list-group-item list-group-item-action ${active === path? 'active' : ''}`

  let html = (
         <>
           <div className={`list-group mw-100`}>
             <Link to="/a7/practice"
                className={isActive(active, '')}>
               <i className="fab fa-twitter fa-stack fa-inverse"></i>
             </Link>
             <Link to="/a7/twitter/home"
                className={isActive(active, 'home')}>
               <i className="fas fa-home fa-inverse"></i> Home
             </Link>
             <Link to="/a7/twitter/explore"
                className={isActive(active, 'explore')}>
               <i className="fas fa-hashtag fa-inverse"></i> Explore
             </Link>
             <Link to=""
                className={isActive(active, 'notifications')}>
               <i className="fas fa-bell fa-inverse"></i> Notifications
             </Link>
             <Link to=""
                className={isActive(active, 'messages')}>
               <i className="fas fa-envelope fa-inverse"></i> Messages
             </Link>
             <Link to=""
                className={isActive(active, 'bookmarks')}>
               <i className="fas fa-bookmark fa-inverse"></i> Bookmarks
             </Link>
             <Link to=""
                   className={isActive(active, 'lists')}>
               <i className="fas fa-list fa-inverse"></i> Lists
             </Link>
             <Link to="/a7/twitter/profile"
                   className={isActive(active, 'profile')}>
               <i className="fas fa-user fa-inverse"></i> Profile
             </Link>
             <Link to=""
                   className={isActive(active, '&nbsp;more')}>
               <i className="fas fa-ellipsis-h fa-inverse"></i> More
             </Link>
           </div>
           <div className={`d-grid mt-2`}>
             <Link to="tweet.html"
                className={`btn btn-primary me-md-2 btn-block rounded-pill`}>
                Tweet>
             </Link>
           </div>
         </>
    );
  return html;
}
export default NavigationSidebar;

